import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

function PageNotFound() {
  return (
    <div className="absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center bg-white text-gray-800">
      <div className="bg-gray-100 p-10 rounded shadow-lg flex flex-col items-center">
        <FontAwesomeIcon icon={faExclamationTriangle} className="h-16 w-16 text-yellow-500 mb-4" />
        <h2 className="text-3xl font-bold mb-4">Page Not Found</h2>
        <p className="text-lg mb-8">The page you are looking for does not exist.</p>
        <Link
          to="/"
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition duration-300"
        >
          Go back to the home page
        </Link>
      </div>
    </div>
  );
}

export default PageNotFound;
